const PrecipIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={props.width ?? 25} height={props.height ?? 24} fill={props.color} viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.8383 2.99994C11.8383 2.99994 5.25 9.98846 5.25 14.4117C5.25 18.0822 8.16778 20.9999 11.8383 20.9999C15.5088 20.9999 18.4266 18.0822 18.4266 14.4117C18.4266 9.98846 11.8383 2.99994 11.8383 2.99994ZM11.8383 19.3529C9.06708 19.3529 6.89707 17.1829 6.89707 14.4117C6.89707 12.1016 9.57603 8.16762 11.8391 5.4796C14.1022 8.16515 16.7795 12.0959 16.7795 14.4117C16.7795 17.1829 14.6095 19.3529 11.8383 19.3529Z" />
    </svg>
);

export default PrecipIcon;